module.exports = __webpack_public_path__ + "static/img/s1511.af584849.png";